module.exports = __webpack_public_path__ + "static/img/SmartPlatform1.9483a57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/SmartPlatform1.png
// module id = zC6W
// module chunks = 13